(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3584],{

/***/ 90569:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/resources",
      function () {
        return __webpack_require__(32222);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15968:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz-color.ffbab323.svg","height":31,"width":96});

/***/ }),

/***/ 33911:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Anz.158dc494.svg","height":31,"width":96});

/***/ }),

/***/ 5002:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers-color.36dfc671.svg","height":44,"width":82});

/***/ }),

/***/ 59874:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/Farmers.b505ac53.svg","height":44,"width":82});

/***/ }),

/***/ 18378:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered-color.d788f387.svg","height":45,"width":111});

/***/ }),

/***/ 86051:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/StandardChartered.590c5a1a.svg","height":45,"width":111});

/***/ }),

/***/ 32222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ pages_resources; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/layouts/LayoutComponents/NextHead.jsx
var NextHead = __webpack_require__(37672);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/landingPage/views/components/form/InfoBox.jsx + 3 modules
var InfoBox = __webpack_require__(40782);
// EXTERNAL MODULE: ./src/landingPage/views/CaseStudy/CaseStudy.module.less
var CaseStudy_module = __webpack_require__(3684);
var CaseStudy_module_default = /*#__PURE__*/__webpack_require__.n(CaseStudy_module);
// EXTERNAL MODULE: ./src/landingPage/views/CaseStudy/components/CaseStudies.module.less
var CaseStudies_module = __webpack_require__(96430);
var CaseStudies_module_default = /*#__PURE__*/__webpack_require__.n(CaseStudies_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./src/landingPage/views/CaseStudy/components/DownloadCaseStudy.jsx
var DownloadCaseStudy = __webpack_require__(8716);
// EXTERNAL MODULE: ./src/landingPage/components/Section/index.jsx + 17 modules
var Section = __webpack_require__(1699);
;// CONCATENATED MODULE: ./src/landingPage/views/CaseStudy/components/CaseStudies.jsx





var resources = [
    {
        title: "Data Hub Chargebacks",
        content: "It seems like it should be straightforward to track the downstream value add and attribute that back to the data team’s central function. This whitepaper outlines the challenges with that.",
        link: "/Demyst - Data Hub Chargebacks.pdf"
    },
    {
        title: "Data Hub Maturity Model",
        content: "Discusses the stages of enterprises’ Data Hub maturity, from no hub to an ever growing and highly leveraged one.",
        link: "/DataHub Maturity Model.pdf"
    },
    {
        title: "External Data Ethics",
        content: "Discusses the ethics of using external data in AI and ML, advocating for an attribute-centric approach, with each attribute evaluated based on provenance, meaning, and biases.",
        link: "/External Data Ethics.pdf"
    },
    {
        title: "External Data Management - Applying the CDMC Framework",
        content: "Data leaders need to consider the risks, responsibilities and opportunities associated with harnessing external data and, across all aspects of the CDMC framework, how external data is necessarily a centrally managed function.",
        link: "/External Data Management - Applying The CDMC Framework.pdf"
    },
    {
        title: "Extracting Business Value from External Data in 2023",
        content: "Demyst’s product team conducted in-depth interviews with data experts across industries and regions on external data adoption. This white-paper summarizes the findings and shares best practices to optimize ROI for data initiatives.",
        link: "/Extracting Business Value from External Data in 2023.pdf"
    },
    {
        title: "The External Data Imperative",
        content: "How external data drives value: More rows (meaning more observations), more columns (meaning more features), and a better analytical algorithm, multiplicatively combine to drive value.",
        link: "/The External Data Imperative.pdf"
    }, 
];
var NewCaseStudies = function(param) {
    var className = param.className;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,clsx_m/* default */.Z)("section-layout", className),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (CaseStudies_module_default()).container,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionTitle */.NZ, {
                    children: "White Papers"
                }),
                resources.map(function(param) {
                    var title = param.title, content = param.content, link = param.link;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: title,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CaseStudies_module_default()).filter
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: (CaseStudies_module_default()).logo
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: title
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: content
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(DownloadCaseStudy/* default */.Z, {
                                className: (CaseStudies_module_default()).cta,
                                autoWidth: true,
                                size: "md",
                                variant: "inverted",
                                url: link,
                                wp: true,
                                "data-test-id": "home-hero-button",
                                title: title,
                                children: "Download White Paper"
                            })
                        ]
                    }, title);
                })
            ]
        })
    });
};
/* harmony default export */ var CaseStudies = (NewCaseStudies);

// EXTERNAL MODULE: ./src/landingPage/components/Hero/index.jsx + 10 modules
var Hero = __webpack_require__(16717);
// EXTERNAL MODULE: ./src/landingPage/components/Button/index.jsx + 3 modules
var Button = __webpack_require__(25504);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/Customers.jsx
var Customers = __webpack_require__(45779);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/BottomCta.jsx
var BottomCta = __webpack_require__(72062);
// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx + 2 modules
var SecurityBadges = __webpack_require__(69753);
;// CONCATENATED MODULE: ./src/landingPage/views/CaseStudy/CaseStudy.jsx











var CaseStudy = function() {
    var ref = (0,react.useState)(false), attentionBox = ref[0], setAttentionBox = ref[1];
    (0,react.useEffect)(function() {
        if (window.location.state) {
            var isInfoboxPresent = window.location.state.infobox;
            if (isInfoboxPresent) setAttentionBox(true);
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            attentionBox && /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoBox/* InfoBox */.v, {
                closeModal: function() {
                    return setAttentionBox(false);
                },
                type: "Attention"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* Hero */.VM, {
                background: "violet-900",
                className: (CaseStudy_module_default()).Hero,
                withStarsAnimation: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Hero/* HeroCol */.Zx, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroTitle */.LR, {
                            multiLine: true,
                            children: "Resource Library"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero/* HeroSubtitle */.RV, {
                            children: "Industry leading content, helping you to unlock the power of external data and level up your organization"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* CtaLinkButton */.k8, {
                            "data-test-id": "home-hero-button"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Customers/* Customers */.S, {
                            withMargin: true
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (CaseStudy_module_default()).case_study,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudies, {
                    className: (CaseStudy_module_default()).overlap
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-800",
                type: "one-col",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BottomCta/* BottomCta */.W, {})
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* Section */.$0, {
                background: "blue-1000",
                removeBottomPadding: true,
                removeTopPadding: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Section/* SectionCol */.JZ, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SecurityBadges/* SecurityBadges */.U, {})
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/landingPage/datasets/meta.js
var meta = __webpack_require__(85666);
;// CONCATENATED MODULE: ./pages/resources.jsx




var CaseStudyPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(NextHead/* NextHead */.B, {
                currentPath: "/resources",
                title: meta/* meta.case_study.title */.$.case_study.title,
                description: meta/* meta.case_study.description */.$.case_study.description
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CaseStudy, {})
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var pages_resources = (CaseStudyPage);


/***/ }),

/***/ 50183:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ logos; }
});

// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers.svg
var Farmers = __webpack_require__(59874);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered.svg
var StandardChartered = __webpack_require__(86051);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz.svg
var Anz = __webpack_require__(33911);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt.png
/* harmony default export */ var Momnt = ({"src":"/_next/static/media/Momnt.30635708.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEX////////zk3/////3v7Xzm4j3xb6ROC7wAAAAB3RSTlNYYkBNaG5HZO0z8gAAAAlwSFlzAAALEwAACxMBAJqcGAAAABlJREFUeJwFwQcBAAAIAyDm6x9ZQJ0WsSPxAPEAGZmuqSMAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/CincinnatiFinance.png
/* harmony default export */ var CincinnatiFinance = ({"src":"/_next/static/media/CincinnatiFinance.4bb80e30.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEVMaXEUVG0aVWwASmoAT2sAVVXFqwtiAAAABnRSTlMAKDMNUgYUvz2rAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJklEQVR4nG3LsREAMAyDQIGc/VfOuTfNVyRH2qXOQJMiwEsQ5Xg+BykAMrwb8LsAAAAASUVORK5CYII="});
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/NAB.svg
/* harmony default export */ var NAB = ({"src":"/_next/static/media/NAB.b100bc4e.svg","height":425,"width":875});
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Farmers-color.svg
var Farmers_color = __webpack_require__(5002);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/StandardChartered-color.svg
var StandardChartered_color = __webpack_require__(18378);
// EXTERNAL MODULE: ./src/landingPage/views/assets/logos/Anz-color.svg
var Anz_color = __webpack_require__(15968);
;// CONCATENATED MODULE: ./src/landingPage/views/assets/logos/Momnt-color.png
/* harmony default export */ var Momnt_color = ({"src":"/_next/static/media/Momnt-color.a6d59b53.png","height":22,"width":110,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAFVBMVEUQLlgUMFd9WWjfg3OLX2kaM1nQfXFqAiexAAAAB3RSTlNcVEdAaGluDzj5NwAAAAlwSFlzAAALEwAACxMBAJqcGAAAABpJREFUeJxjYGRkZmJgZGRgYGBgY2FkZWAAAADeABp7a5gYAAAAAElFTkSuQmCC"});
;// CONCATENATED MODULE: ./src/constants/CustomerLogos.js





// import IAG from "../landingPage/views/assets/logos/IAG.png";





var logos = {
    default: [
        {
            src: NAB.src,
            alt: "NAB",
            width: "150",
            height: "60"
        },
        {
            src: Anz/* default.src */.Z.src,
            alt: "ANZ",
            width: "100",
            height: "35",
            isAnz: true
        },
        {
            src: Momnt.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        },
        {
            src: StandardChartered/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Farmers/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        // { src: IAG.src, alt: "IAG", width: "80", height: "80" },
        {
            src: CincinnatiFinance,
            alt: "Cincinnati",
            width: "120",
            height: "120",
            isBrightLogo: true
        }, 
    ],
    color: [
        {
            src: Anz_color/* default.src */.Z.src,
            alt: "ANZ",
            width: "96",
            height: "31"
        },
        {
            src: Farmers_color/* default.src */.Z.src,
            alt: "Farmers Insurance",
            width: "82",
            height: "44"
        },
        {
            src: StandardChartered_color/* default.src */.Z.src,
            alt: "Standard Chartered",
            width: "111",
            height: "45"
        },
        {
            src: Momnt_color.src,
            alt: "Momnt",
            width: "110",
            height: "22"
        }, 
    ]
};


/***/ }),

/***/ 72062:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "W": function() { return /* binding */ BottomCta; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Section__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1699);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25504);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67039);
/* harmony import */ var _BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3__);




var BottomCta = function() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().divReadyToGetStarted),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Section__WEBPACK_IMPORTED_MODULE_1__/* .SectionHeading */ .OT, {
                        type: "h2",
                        children: "Ready to get started?"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().lestUsSectionColor),
                        children: "See why our customer continue to trust and leverage Demyst to accelerate their external data initiatives."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_2__/* .CtaLinkButton */ .k8, {
                    autoWidth: true,
                    classNameDiv: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsButton),
                    className: (_BottomCta_module_less__WEBPACK_IMPORTED_MODULE_3___default().letUsText),
                    text: "Let us show you how"
                })
            })
        ]
    });
};


/***/ }),

/***/ 45779:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "S": function() { return /* binding */ Customers; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(86010);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48900);
/* harmony import */ var _Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_Customers_module_less__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50183);





var Customers = function(param) {
    var className = param.className, _header = param.header, header = _header === void 0 ? "Join the customers already unlocking the power of external data with Demyst:" : _header, _variant = param.variant, variant = _variant === void 0 ? "default" : _variant, _align = param.align, align = _align === void 0 ? "center" : _align, _withMargin = param.withMargin, withMargin = _withMargin === void 0 ? false : _withMargin;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().Customers), withMargin && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersMargin), align === "center" && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersAlignCenter), className),
        children: [
            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersHeader),
                style: {
                    marginBottom: "40px"
                },
                children: header
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlider),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosTrack),
                    children: Array(2).fill().map(function() {
                        var ref;
                        return (ref = _constants_CustomerLogos__WEBPACK_IMPORTED_MODULE_2__/* .logos */ .U[variant]) === null || ref === void 0 ? void 0 : ref.map(function(i) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (0,clsx__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().CustomersLogosSlide), i.isBrightLogo && (_Customers_module_less__WEBPACK_IMPORTED_MODULE_4___default().BrightLogo)),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                                    priority: false,
                                    src: i.src,
                                    alt: i.alt,
                                    width: i.width,
                                    height: i.height
                                })
                            }, i.alt);
                        });
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 69753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ SecurityBadges; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/landingPage/components/Badge/Badge.module.less
var Badge_module = __webpack_require__(86919);
var Badge_module_default = /*#__PURE__*/__webpack_require__.n(Badge_module);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
;// CONCATENATED MODULE: ./src/landingPage/components/Badge/Badge.jsx




var Badge = function(param) {
    var icon = param.icon, _background = param.background, background = _background === void 0 ? "violet-1000" : _background, children = param.children;
    var backgroundClassName = typeof background === "string" ? background.replace(/-/g, "_").toLowerCase() : typeof background === "object" ? background.map(function(bg) {
        return bg.replace(/-/g, "_").toLowerCase();
    }).join("_to_") : null;
    var iconToShow = icon ? typeof icon === "function" ? icon() : typeof icon === "string" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
        src: icon,
        alt: ""
    }) : null : typeof icon === "object" ? icon : /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiCheckCircle */._rq, {});
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx_m/* default */.Z)((Badge_module_default()).Badge, (Badge_module_default())[backgroundClassName]),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Badge_module_default()).BadgeIcon,
                children: iconToShow
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                className: (Badge_module_default()).BadgeLabel,
                children: children
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/landingPage/components/Badge/index.jsx


// EXTERNAL MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.module.less
var SecurityBadges_module = __webpack_require__(68760);
var SecurityBadges_module_default = /*#__PURE__*/__webpack_require__.n(SecurityBadges_module);
;// CONCATENATED MODULE: ./src/landingPage/components/subcomponents/SecurityBadges.jsx



var SecurityBadges = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (SecurityBadges_module_default()).SecurityBadges,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "SOC 2 Type II"
                    }),
                    " Certified"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GDPR"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "CCPA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "FCRA"
                    }),
                    " Compliant"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Badge, {
                background: "blue-1000",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        children: "GLBA"
                    }),
                    " Compliant"
                ]
            })
        ]
    });
};


/***/ }),

/***/ 85666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ meta; }
/* harmony export */ });
var meta = {
    homepage: {
        title: "Demyst: The External Data Management Platform",
        description: "Demyst enables data teams to manage all their external data. External data orchestration at scale, with pipelines that provide trusted external data."
    },
    platform: {
        title: "The Demyst Platform",
        description: "Use Demyst to build your External Data Hub. Demyst provides the end-to-end platform you need to onboard and ingest the right external data into your Data Hub, with our experts working closely with you every step of the way."
    },
    platform_discover: {
        title: "Data Discovery",
        description: "Access hundreds of fully integrated sources, or easily request something new with the Demyst Platform."
    },
    platform_management: {
        title: "Maintenance & Support",
        description: "Simplify the management of all your external data with a single global interface to reduce maintenance burden and maximize value."
    },
    platform_governance: {
        title: "Governance, Procurement & Compliance",
        description: "Say goodbye to the “Compliance Versus Speed” trade-off. Meet industry leading compliance practices whilst typically onboarding new data in four weeks or less."
    },
    platform_deployment: {
        title: "Deployment",
        description: "Deploy up to ten times the data, ten times faster with the Demyst Platform."
    },
    whydataops: {
        title: "Frictionless External Data",
        description: "Keeping pace with the expanding universe of external data is painful without the right technology supporting you."
    },
    ccpa: {
        title: "CCPA",
        description: "Personal Information Request Form for California Residents"
    },
    dsar: {
        title: "DSAR",
        description: "Data Subject Action Request"
    },
    case_study: {
        title: "Resources",
        description: "Meet the industry leaders across the globe that are unlocking the power of external data with Demyst."
    },
    about: {
        title: "About us",
        description: "Demyst believes that external data is the next frontier of business impact, able to power competitive advantages in industries around the world with improved decisioning, new products and better efficiencies."
    },
    contact: {
        title: "Contact us",
        description: "Contact us with the form below to learn how Demyst helps you discover, access, license, and deploy data using our end-to-end EDaaS (External Data as a Service) offering, or if you have any other general inquiries."
    },
    request: {
        title: "Schedule a Demo",
        description: "Schedule a Demo with the form below to learn how the Demyst platform empowers users to discover, access, license, and deploy external data."
    },
    careers: {
        title: "Careers",
        description: "Join our team to immerse yourself in an ecosystem of strategic business challenges and opportunities and awe-inspiring data access."
    },
    report: {
        title: "Free Discovery Report",
        description: "Our free data discovery report gives you a summary of the specific data sources, attributes, analytics, and integration models you can use to solve your business challenges."
    },
    privacy: {
        title: "Privacy Policy",
        description: "This Privacy Policy describes what information we collect when you use our Software, how we use that information, and what choices we offer you to access, update, and control it."
    },
    accessibility: {
        title: "Accessibility Policy",
        description: "This Accessibility Policy outlines the measures we have put in place to ensure that our service is inclusive and usable by as many people as possible"
    },
    terms: {
        title: "Terms and Conditions",
        description: "Demyst Data Limited and its affiliated companies (together, “Demyst Data” or “we” and sometimes “us”) provide the websites www.demystdev.wpengine.com and demystdata.com (collectively, the “Website”) and the Demyst Data software and libraries (collectively referred to herein as the/our “Software” or the/our “Services”), subject to your agreement to and compliance with these Terms and Conditions (the “Terms”)."
    },
    cookies: {
        title: "Cookies Policy",
        description: "This policy explains the different cookies used by Demyst Data on our corporate website and on our Platform (collectively, “Site”) and how you can control them. We may change this Cookie Policy at any time. Please look at the “Last Updated” date at the top of this page to see when this Cookie Policy was last revised. Any changes in this Cookie Policy will become effective when we make the revised Cookie Policy available on or through the  Site. Please see our Privacy Notice to understand the other ways we use the personal information we collect about you."
    },
    subprocessor: {
        title: "Sub-processor Policy",
        description: "Demyst uses certain Sub-contractors (Processors where we act in a “Data Controller” capacity or Sub-processors where we act in a“Data Processor” capacity) to assist it in providing Demyst’s services, including the processing of personal data."
    },
    business: {
        title: "Business Data",
        description: "Harness hundreds of operationalized data sources and marketplaces, through a single API."
    },
    demystvs: {
        title: "Demyst vs. Data Consulting",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxfincrime: {
        title: "Demyst DataOps for FinCrime",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxpartnership: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst has a purpose built platform to connect you to the data you need and deliver it quickly into production."
    },
    adxexchange: {
        title: "Demyst and AWS Data Exchange",
        description: "Demyst and the Amazon Web Services (AWS) Data Exchange help customers get data into production to achieve data-driven business outcomes faster."
    },
    industries: {
        financialservices: {
            title: "Financial Services Industry",
            description: "Rapidly deploy the right external data solutions for financial services. Optimize your external data spend with a single platform."
        },
        insurance: {
            title: "Insurance Industry",
            description: "Rapidly deploy the right external data solutions for insurance."
        }
    },
    enterprise: {
        title: "Enterprise",
        description: "Delivering End-To-End Value Across The Enterprise."
    },
    newsletter: {
        title: "Newsletter",
        description: "A weekly summary of Demyst product activities and general news impacting the market for external data."
    },
    pricing: {
        title: "Pricing",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    partners: {
        title: "Partners",
        description: "Flexible Options, Transparent Pricing. Select the right plan for your business."
    },
    usecases: {
        bnpl: {
            title: "Automate Buy Now, Pay Later",
            description: "Access ready-to-deploy data APIs for KYC, Fraud, Compliance and Credit Decisioning , aggregating global data from multiple data partners into a single, configurable data feed."
        },
        kyc: {
            title: "KYC Workflow Automation",
            description: "A single platform for seamless onboarding and verification of customers globally."
        },
        kyb: {
            title: "KYB Workflow Automation",
            description: "A single platform for seamless onboarding and verification of businesses globally."
        },
        applicationprefill: {
            title: "Application Prefill Optimization",
            description: "A single platform for prefilling data pertaining to people, places, and businesses, globally."
        },
        dataenrichment: {
            title: "Enrich Leads",
            description: "A single platform to identify new leads (person, place, business) globally."
        },
        leadtargeting: {
            title: "Optimize Lead Targeting",
            description: "A single platform to identify new leads, enrich leads, and priortiize leads across people, places, and businesses, globally."
        },
        portfoliomonitoring: {
            title: "Optimize Portfolio Monitoring",
            description: "A single platform to enrich customer profiles for retention and cross-sell intiatives"
        },
        businessdecisioning: {
            title: "Business Customer Onboarding",
            description: "Build an initial business customer profile to enable improved new business onboarding decisions and minimize risk exposure."
        },
        creditbureau: {
            title: "Optimize Credit Decisioning",
            description: "A single platform to integrate and manage credit bureau feeds globally."
        }
    }
};


/***/ }),

/***/ 84135:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ LinkButton; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(86010);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65966);







var LinkButton = function(_param) {
    var _autoWidth = _param.autoWidth, autoWidth = _autoWidth === void 0 ? false : _autoWidth, _demystIcon = _param.demystIcon, demystIcon = _demystIcon === void 0 ? false : _demystIcon, hidden = _param.hidden, isExternal = _param.isExternal, onClick = _param.onClick, _variant = _param.variant, variant = _variant === void 0 ? "primary" : _variant, _size = _param.size, size = _size === void 0 ? "lg" : _size, disabled = _param.disabled, to = _param.to, children = _param.children, className = _param.className, _noStyle = _param.noStyle, noStyle = _noStyle === void 0 ? false : _noStyle, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "autoWidth",
        "demystIcon",
        "hidden",
        "isExternal",
        "onClick",
        "variant",
        "size",
        "disabled",
        "to",
        "children",
        "className",
        "noStyle"
    ]);
    var classes = noStyle !== true ? (0,clsx__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("button-component", variant === "inverted" && "button-component-inverted", variant === "secondary" && "button-component-secondary", variant === "secondary-alt" && "button-component-secondary-alt", hidden && "hidden", autoWidth && "button-component-autoWidth", size && "button-component-size-".concat(size), disabled && "button-component-disabled", className) : className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        href: to,
        className: classes,
        onClick: function(e) {
            onClick && onClick(e);
        }
    }, isExternal && {
        target: "_blank",
        rel: "noreferrer"
    }, props), {
        children: [
            noStyle !== true ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                children: children
            }) : children,
            demystIcon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                src: _assets_Demyst_svg__WEBPACK_IMPORTED_MODULE_2__/* ["default"].src */ .Z.src,
                alt: "",
                width: "16",
                height: "22",
                loading: "eager"
            })
        ]
    }));
};


/***/ }),

/***/ 40782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v": function() { return /* binding */ InfoBox; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Attention.svg
/* harmony default export */ var Attention = ({"src":"/_next/static/media/Attention.623c0e2a.svg","height":18,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Error.svg
/* harmony default export */ var Error = ({"src":"/_next/static/media/Error.ff5ef9c7.svg","height":20,"width":20});
;// CONCATENATED MODULE: ./src/landingPage/assets/svg/InfoBox/Success.svg
/* harmony default export */ var Success = ({"src":"/_next/static/media/Success.47ce7b03.svg","height":20,"width":20});
// EXTERNAL MODULE: ./node_modules/react-icons/fi/index.mjs
var fi = __webpack_require__(2777);
// EXTERNAL MODULE: ./src/constants/linksConstants.js
var linksConstants = __webpack_require__(71571);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/landingPage/views/components/form/InfoBox.jsx









var getIcon = function(type) {
    switch(type){
        case "Attention":
            return Attention.src;
        case "Success":
            return Success.src;
        default:
            return Error.src;
    }
};
var getMessage = function(type) {
    switch(type){
        case "Attention":
            return "The page you tried to access does not exist. If you think this is a mistake, please contact Demyst support.";
        case "Success":
            return "Your form has been sent successfully. We'll be in touch.";
        default:
            return "There was an unexpected internal error with our server. Please contact Demyst support.";
    }
};
var getActionText = function(type) {
    switch(type){
        case "Success":
            return "Return Home";
        default:
            return "Contact Support";
    }
};
var getActionLink = function(type) {
    switch(type){
        case "Success":
            return linksConstants/* linksConstants.HOME */.s.HOME;
        default:
            return linksConstants/* linksConstants.CONTACT */.s.CONTACT;
    }
};
var InfoBox = function(param) {
    var actionLink = param.actionLink, actionText = param.actionText, _actionVisible = param.actionVisible, actionVisible = _actionVisible === void 0 ? true : _actionVisible, closeModal = param.closeModal, _fromContact = param.fromContact, fromContact = _fromContact === void 0 ? false : _fromContact, text = param.text, title = param.title, _type = param.type, type = _type === void 0 ? "Success" : _type;
    var ref = (0,react.useState)(false), componentMounted = ref[0], setComponentMounted = ref[1];
    (0,react.useEffect)(function() {
        setTimeout(function() {
            return setComponentMounted(true);
        }, 200);
    }, []);
    var closeWithFade = function() {
        setComponentMounted(false);
        setTimeout(function() {
            closeModal();
        }, 500);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
        className: "info_box-main ".concat(componentMounted ? "" : "initiated"),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "info_box-icon_box ".concat(type.toLowerCase()),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    className: "info_box-icon",
                    src: getIcon(type),
                    alt: type
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "info_box-text",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: "info_box-header",
                        children: title || "".concat(type, "!")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "info_box-message",
                        children: text || getMessage(type)
                    }),
                    actionVisible && !fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    }),
                    actionVisible && fromContact && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        onClick: closeModal,
                        className: "info_box-action",
                        href: actionLink || getActionLink(type),
                        children: actionText || getActionText(type)
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                className: "info_box-close",
                onClick: function() {
                    return closeWithFade();
                },
                title: "Close",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(fi/* FiX */.q5L, {})
            })
        ]
    });
};
InfoBox.propTypes = {
    actionLink: (prop_types_default()).string,
    actionText: (prop_types_default()).string,
    actionVisible: (prop_types_default()).bool,
    closeModal: (prop_types_default()).func,
    fromContact: (prop_types_default()).bool,
    text: (prop_types_default()).string,
    title: (prop_types_default()).string,
    type: (prop_types_default()).string
};


/***/ }),

/***/ 86919:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Badge":"Badge_Badge__XqccE","blue_800":"Badge_blue_800__umxh_","blue_900":"Badge_blue_900__B9XkS","blue_1000":"Badge_blue_1000__UZDMq","violet_1000":"Badge_violet_1000__So3zY","BadgeLabel":"Badge_BadgeLabel__vt7Tn"};

/***/ }),

/***/ 67039:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"BottomCta":"BottomCta_BottomCta__VRmZc","lestUsSectionColor":"BottomCta_lestUsSectionColor__cKutT","letUsText":"BottomCta_letUsText__TbXdV","divReadyToGetStarted":"BottomCta_divReadyToGetStarted__nkl4j","letUsButton":"BottomCta_letUsButton__0YB3K","BottomCtaCol":"BottomCta_BottomCtaCol__xDN69","BottomCtaList":"BottomCta_BottomCtaList__1rBcr","BottomCtaListItem":"BottomCta_BottomCtaListItem__Ojioj"};

/***/ }),

/***/ 48900:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"Customers":"Customers_Customers__4fdox","CustomersMargin":"Customers_CustomersMargin__LJDSh","CustomersHeader":"Customers_CustomersHeader__6lKvo","CustomersLogosSlider":"Customers_CustomersLogosSlider__XT3_j","CustomersLogosTrack":"Customers_CustomersLogosTrack__u_0zQ","trackslide":"Customers_trackslide__HouPN","CustomersLogosSlide":"Customers_CustomersLogosSlide__UUzik","BrightLogo":"Customers_BrightLogo__dFg_w"};

/***/ }),

/***/ 68760:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"SecurityBadges":"SecurityBadges_SecurityBadges__RilZo"};

/***/ }),

/***/ 3684:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"case_study":"CaseStudy_case_study__V2kzr","hero":"CaseStudy_hero__t0G02","overlap":"CaseStudy_overlap___dWhG","background_white":"CaseStudy_background_white__rrMsR","button":"CaseStudy_button__T7kB9"};

/***/ }),

/***/ 96430:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"CaseStudies_container__YwetV","logo":"CaseStudies_logo__Hvj4_","filter":"CaseStudies_filter___2_If","cta":"CaseStudies_cta__OZHqT"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3430,1664,2777,314,5675,8540,9223,4280,8716,9774,2888,179], function() { return __webpack_exec__(90569); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);